import { render, staticRenderFns } from "./theme.md?vue&type=template&id=00267b3e&"
import script from "./theme.md?vue&type=script&lang=js&"
export * from "./theme.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00267b3e')) {
      api.createRecord('00267b3e', component.options)
    } else {
      api.reload('00267b3e', component.options)
    }
    module.hot.accept("./theme.md?vue&type=template&id=00267b3e&", function () {
      api.rerender('00267b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/theme.md"
export default component.exports